import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import FilterComponent from '@components/Default/Search/FilterComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import ModalHeader from '@components/GoEpikUI/Modal-related/ModalHeader';
import GoEpikModal from '@components/Modal';
import Page from '@components/Page';
import StepsVisualizer from '@components/StepsVisualizer/StepsVisualizer';
import TableComponent, { ITableColumn } from '@components/TableComponent';
import { UsersForm } from '@components/UsersForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NotificationComponent from '@helpers/_showNotifications';
import { PlatformComponents } from '@helpers/Enums';
import { ConfigGLOBAL, FieldType, IField } from '@interfaces/global/config-global';
import IPagination from '@interfaces/IPagination';
import { IUser } from '@interfaces/IUser';
import IUserExtraFieldsState from '@interfaces/IUserExtraFieldsState';
import AppContext from '@services/Context';
import ConfigService from '@services/global/Config';
import RoleService from '@services/RoleService';
import UserGroupService from '@services/UserGroupService';
import UserService from '@services/UserService';
import UserFormExtra from '@src/forms/UserForms';
import I18n from '@src/i18n';
import styled, { injectGlobal } from '@src/styled-components';
import { Button, Checkbox, Col, Divider, Form, Icon, Input, Modal, Row, Select, Tabs } from 'antd';
import * as _ from 'lodash';
import findIndex from 'lodash/findIndex';
import React from 'react';
import GroupManager from '../components/Group/GroupManager'

import { LocalStorageKeys } from './App';
import { ExportContainer } from './ExportImportContainer';
import GroupService from '@services/graphQL/graphQLGroup'
import verifyItemPermission from '@helpers/verifyItemPermission'
import { Pillar } from '@interfaces/pillar'

const groupService = new GroupService()
const TabPane = Tabs.TabPane;
const CheckboxGroup = Checkbox.Group;
const Option = Select.Option;
const confirm = Modal.confirm;

interface IUserExtraFieldList {
  index: number,
  name: string,
  values: string[],
  isVisible: boolean,
};


interface IUsersContainerPropType {
  history: { replace: Function };
  match: any;
  onUpdate: Function;
  form: any;
}

interface IUsersContainerStateType extends IUserExtraFieldsState {
  activeKey?: string,
  curOffset?: string,
  currentList: IUserExtraFieldList,
  disabled?: boolean,
  editItem: any,
  extraFieldToDelete: any,
  filteredTableData: IUser[],
  iconLoading?: boolean,
  isConfigExtraFieldsModalVisible: boolean,
  isLoading: boolean,
  isRegistrationModalVisible: boolean,
  isTableSet: boolean,
  loadingTable?: boolean,
  name: string,
  newUserExtraField: IField,
  numberField: number,
  search: string,
  tableColumns?: ITableColumn[],
  tableData: IUser[],
  countGroup: number,
  groupAmount: number,
  groupLimit: number,
  totalShowData: number,
  type: string,
  userAmount: number,
  userExtraFields: IField[],
  value: string[],
  formEditItem: any,
  isDeletingExtraField: boolean
  isDeletingUser: boolean;
  visibleDelete: boolean;
  roles?: any;
  hasExtraFields: boolean;
  groupTableData: any;
  groupTableDataTotal: any;
  registerGroupModal: boolean;
  edititemsGroup: any;
  groupName: string;
  components: any[];
  selectedGroupsObject: {};
  editedGroupPermissions: any;
  editionMode: boolean;
  showPermissionsModal: boolean;
  groups: any;
  loadingGroups: any;
  loadingUsers: any;
};

const groupsColumns = [{
  title: 'table.profile.name',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
}
];

export default class UsersContainerClass extends React.Component<IUsersContainerPropType, IUsersContainerStateType> {

  private activeUnitId: string;
  private locale?: string;
  private _userService: UserService;
  private _userGroupService: UserGroupService;
  private _configService: ConfigService;
  private _userForm: UserFormExtra;
  private currentPillar: string = String(localStorage.getItem(LocalStorageKeys.PILLAR))
  private readonly _roleSvc: RoleService;

  constructor(props: any) {
    super(props);

    this.activeUnitId = "";
    this.locale = "";
    this._roleSvc = new RoleService();

    this._userForm = new UserFormExtra();

    this._userService = new UserService();
    this._userGroupService = new UserGroupService();
    this._configService = new ConfigService();
    this.currentPillar = String(localStorage.getItem(LocalStorageKeys.PILLAR))

    this.formatResponseDataToSave = this.formatResponseDataToSave.bind(this);
    this.loadGroups = this.loadGroups.bind(this)

    this.state = {
      activeKey: '1',
      curOffset: undefined,
      currentList: {
        index: 0,
        name: '',
        values: [],
        isVisible: false
      },
      disabled: undefined,
      editItem: {
        createdAt: undefined,
        disabled: false,
        email: '',
        fields: [],
        extraFields: {},
        id: undefined,
        name: '',
        phone: '',
        units: [this.activeUnitId],
        username: '',
        roles: [],
        group: []
      },
      extraFields: new Array<IField>(),
      extraFieldsCheckboxesIds: new Array<string>(), // used to control which checkboxes are checked
      extraFieldToDelete: null,
      filteredTableData: [],
      formEditItem: [],
      iconLoading: false,
      isConfigExtraFieldsModalVisible: false,
      isDeletingExtraField: false,
      isLoading: true,
      isRegistrationModalVisible: false,
      isTableSet: false,
      loadingTable: false,
      name: '',
      newUserExtraField: { name: undefined, type: undefined },
      numberField: 1,
      search: '',
      tableColumns: [],
      tableData: [],
      countGroup: 0,
      groupAmount: 0,
      groupLimit: 10,
      totalShowData: 5,
      type: '',
      userAmount: 0,
      userExtraFields: new Array<IField>(),
      value: [],
      visibleExtraFieldsIds: new Array<string>(), // used to control which columns are visible
      isDeletingUser: false,
      visibleDelete: false,
      hasExtraFields: false,
      groupTableData: [],
      groupTableDataTotal: [],
      registerGroupModal: false,
      edititemsGroup: { id: '', name: '' },
      groupName: '',
      components: [
        {key: PlatformComponents.DASHBOARD, label: "routes.dashboard"},
        {key: PlatformComponents.PROCESS_MANAGER, label: "labels.processmanagement"}, 
        {key: PlatformComponents.USER, label: "common.users"}, 
        {key: PlatformComponents.PROCESS, label: "common.processes"}, 
        {key: PlatformComponents.MODEL3D, label: "routes.model3d"},
        {key: PlatformComponents.QR_CODE, label: "routes.targets"},
        {key: PlatformComponents.SCHEDULER, label: "routes.scheduler"},
        {key: PlatformComponents.HISTORY, label: "titles.history"}],
      selectedGroupsObject: {},
      editedGroupPermissions: [],
      editionMode: false,
      showPermissionsModal: false,
      groups: [],
      loadingGroups: false,
      loadingUsers: true
    }
  }

  /**
   * Gets initial table columns. Those are immutable
   * @returns ITableColumn[]
   */
  getInitialTableColumns = (): ITableColumn[] => {

    let profileColumn = {}
    if (this.currentPillar !== "LI") {
      return [{
        title: 'table.users.name',
        dataIndex: 'name',
        key: 'name',
        width: 225
      },
      {
        title: 'label.groups',
        dataIndex: 'group_s',
        key: 'group_s',
        width: 225
      },
      {
        title: 'table.users.username',
        dataIndex: 'username',
        key: 'username',
        width: 225
      },
      {
        title: 'table.users.email',
        dataIndex: 'email',
        key: 'email',
        width: 225
      },
      {
        title: 'table.users.phone',
        dataIndex: 'phone',
        key: 'phone',
        width: 225
      },
      {
        title: 'table.users.profile',
        dataIndex: 'perfil',
        key: 'perfil',
        width: 225
      },
      {
        title: 'table.products.createdAt',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 225
      },
      {
        title: 'table.actions',
        dataIndex: 'action',
        key: 'action',
        width: 225

      }] as ITableColumn[];

    }
    else {
      return [{
        title: 'table.users.name',
        dataIndex: 'name',
        key: 'name',
        width: 225
      },
      {
        title: 'label.groups',
        dataIndex: 'group_s',
        key: 'group_s',
        width: 225
      },
      {
        title: 'table.users.username',
        dataIndex: 'username',
        key: 'username',
        width: 225
      },
      {
        title: 'table.users.email',
        dataIndex: 'email',
        key: 'email',
        width: 225
      },
      {
        title: 'table.users.phone',
        dataIndex: 'phone',
        key: 'phone',
        width: 225
      },
      {
        title: 'table.products.createdAt',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 225
      },
      {
        title: 'table.actions',
        dataIndex: 'action',
        key: 'action',
        width: 225

      }] as ITableColumn[];
    }
  };

  // Loads everything on screen
  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    await this.getRoles();
    await this.setExtraFieldsState();
    await this.getConfig();
    await this.setTable();
    await this.getGroups();
    await this.loadGroups()
    await this.getUsers(true);
  }

  getRoles = async () => {
    let roles: any = []
    if (this.currentPillar !== 'LI') {
      roles = await this._roleSvc.listAll();
    }
    this.setState({ roles })
  }

  setExtraFieldsState = async () => {
    try {
      const dataGlobal = await this._configService.getGLOBAL();


      const extraFields = dataGlobal.userFields;
      this.setState({
        extraFields
      });
      //erro
      const visibleIds: string[] = [];
      extraFields.forEach((extraField: IField) => {
        if (extraField.id) {
          if (Boolean(localStorage.getItem(extraField.id)) === true) { // If true, it's visible
            visibleIds.push(extraField.id);
          }
        }
      });

      this.setState({
        visibleExtraFieldsIds: visibleIds,
        extraFieldsCheckboxesIds: visibleIds,
      });

    } catch (error) {
      console.error("error on fetching extra fields", error)
    }
  }

  setTable = async () => {
    this.setState({
      isTableSet: false,
      tableColumns: []
    });

    const _tableColumns = this.getInitialTableColumns();
    let _newColumn: ITableColumn;

    this.state.extraFields.map((field: IField) => {

      if (field.id && field.name) {
        _newColumn = {
          title: field.name,
          dataIndex: field.id,
          key: field.id,
          isHidden: !this.getVisibilityFromState(field.id),
          width: 225
        }
      }
      _tableColumns.splice(5, 0, _newColumn);
    });


    this.setState({
      tableColumns: _tableColumns,
      isTableSet: true
    });
  }

  getVisibilityFromState = (fieldId: string): boolean => {
    return this.state.visibleExtraFieldsIds.includes(fieldId);
  }

  onTabChange = (activeKey: string): void => {
    this.setState({ activeKey });
  }

  handleNameChange = (evt: any) => {
    this.setState({ name: evt.target.value });
  }

  handleValueChange = (evt: any) => {

    this.setState({ type: evt.target.value });
  }

  handleUserExtraFieldNameChange = (idx: number) => (evt: any) => {
    const newUserExtraField = this.state.userExtraFields.map((userExtraField, sidx) => {
      if (idx !== sidx) return userExtraField;
      return { ...userExtraField, name: evt.target.value };
    });

    // Handles list possible name change
    // This means we are editing a current visible list
    if (this.state.currentList.index === idx && this.state.currentList.isVisible) {

      const newList = this.state.currentList;
      newList.name = evt.target.value;

      this.setState({
        currentList: newList
      });
    }

    this.setState({ userExtraFields: newUserExtraField });
  }

  handleListFieldValueChange = (idx: number) => (evt: any) => {
    const value = evt.target.value;
    const currentList = this.state.currentList;

    currentList.values[idx] = value;

    this.setState({
      currentList
    });
  }

  handleUserExtraFieldTypeChange = (idx: any) => (value: any) => {
    const newUserExtraField = this.state.userExtraFields.map((userExtraField, sidx) => {
      if (idx !== sidx) return userExtraField;
      return { ...userExtraField, type: value };
    });

    this.setState({ userExtraFields: newUserExtraField });
  }

  handleSubmit = async () => {
    const { userExtraFields } = this.state;
    let addedField = false;
    try {
      const data: any = {
        userFields: [] = userExtraFields
      };
      await this._configService.updateGLOBAL(data);
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userInfoSuccess"));
      addedField = true;
    }
    catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
    }

    await this.setExtraFieldsState();
    if (addedField) {
      await this.getConfig();
    }
    await this.setTable();
    // await this.getUsers(true);
  }

  handleAddUserExtraField = async () => {

    const userExtraFields = this.state.userExtraFields;
    userExtraFields.push({ name: undefined, type: undefined });

    this.setState({
      userExtraFields
    });
  }

  handleAddNewListItem = async () => {
    const currentList = this.state.currentList;

    currentList.values.push("");

    this.setState({
      currentList
    });
  }

  handleRemoveListItem = (idx: number) => async () => {

    const currentList = this.state.currentList;
    currentList.values = currentList.values.filter((s, sidx) => idx !== sidx);

    this.setState({
      currentList
    })
  }

  // TODO: fix state method to take into account the role addition
  toggleFormModal = async (cleanEditItem?: boolean) => {
    if (cleanEditItem) {
      this.setState({
        formEditItem: []
      });
    }

    this.setState({
      isRegistrationModalVisible: !this.state.isRegistrationModalVisible,
      editItem: {
        // code: '',
        id: undefined,
        units: [this.activeUnitId],
        disabled: true,
        name: '',
        username: '',
        phone: '',
        email: '',
        fields: [],
        extraFields: {}
        // roles: [] // FIXME: Is this right?
      },
    });
  }

  toggleExtraFieldsConfigModal = () => {
    this.setState({
      isConfigExtraFieldsModalVisible: !this.state.isConfigExtraFieldsModalVisible,
    });
  }

  toggleModalGroup = async () => {
    this.setState({
      registerGroupModal: !this.state.registerGroupModal,
      edititemsGroup: { id: '', name: '' }
    })
    this.getGroups();
  }

  openEditGroup = async (items: any) => {
    this.setState({ 
      registerGroupModal: true, 
      edititemsGroup: { id: items.id, name: items.name }, 
      selectedGroupsObject: items.permissions,
      editionMode: true })
    this.getGroupPermissions(items)
  }

  editPermissions = async() => {

    try{
      const object = {
        name: this.state.groupName !== '' ? this.state.groupName : this.state.edititemsGroup.name,
        permissions: this.state.selectedGroupsObject
      }
  
      await this._userGroupService.updateById(this.state.edititemsGroup.id, object)
      await this.getGroups();
      this.clearUserGroupState();
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.groupEdited"));
    } catch (e){
      NotificationComponent.Notify('error', I18n.l("common.error"), 'error');
    }
  }

  getGroupPermissions = async (items: any) => {
    const permissionsStrings: string[] = []
    if(items.permissions){
      const allowedComponents = Object.keys(items.permissions)

      for(let component of allowedComponents){
        items.permissions[component].forEach((permission: string) => {
          permissionsStrings.push(`${component}-${permission}`)
        })
      }

    this.setState({editedGroupPermissions: permissionsStrings})
    }
  }

  deleteGroup = async (items: any) => {
    const { groupTableData } = this.state;
    const nextTableData = groupTableData.filter((item: IUser) => item.id !== items);

    try {
      await this._userGroupService.deleteById(items);
      this.setState({
        groupTableData: nextTableData,
      });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.groupDelete"));
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
    }
  }

  onSaveGroup = async (values: any) => {
    try {
      let data = this.state.groupTableData;
      if (this.state.edititemsGroup.id !== '') {
        data = await this._userGroupService.updateById(this.state.edititemsGroup.id, values)
        const indexUpdated = this.state.groupTableData.findIndex((e: any) => e.id === this.state.edititemsGroup.id)
        this.state.groupTableData[indexUpdated].name = values.name
        NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.groupEdited"));
      }
      else {
        data = await this._userGroupService.create(values)
        this.state.groupTableData.push(data)
        NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.groupCreated"));
      }
      this.setState({
        groupTableData: this.state.groupTableData,
        edititemsGroup: { id: '', name: '' },
        registerGroupModal: false
      })
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
    }

  }
  listGroups() {
    const options: JSX.Element[] = []
    for (let items of this.state.groupTableData) {
      options.push(
        <Option key={items.id} value={items.id}>{items.name}</Option>
      )
    }
    return options;
  }

  // GAMBS: Roles are not present in this context, even though the interface was changed
  getInputDataToSave = (input: any) => {

    const phoneInput = input.phone ? `+${input.phone.replace(/[^0-9]/g, '')}` : '';

    const data = {
      units: [this.activeUnitId],
      id: input.id,
      name: input.name,
      username: input.username,
      email: input.email,
      phone: phoneInput,
      createdAt: input.createdAt,
      group: input.group,
      group_s: input.group_s
      // roles: [] // FIXME: what?
    }


    // MONSTER GAMBS: filtra os campos de select
    /**
     * Essa rotina remove os campos "obrigatórios" do objeto que vem montado pelo formbuilder para montar o objeto 
     * necessário para o backend. Orientação à objeto pra que?!
     */
    const fieldsToRemove = ['name', 'id', 'createdAt', 'create', 'username', 'email', 'phone', 'group'];
    const dataFields: any = [];

    const fieldsKeys = Object.keys(input);
    fieldsKeys.map(f => {
      if (!fieldsToRemove.includes(f)) {
        dataFields.push({
          'value': input[f],
          'label': f
        })
      }
    });


    data['fields'] = dataFields;

    return data;
  }

  formatResponseDataToSave(input: any, response: any) {
    const resFormat = {
      units: [this.activeUnitId],
      id: response.id,
      name: response.name,
      username: response.username,
      email: response.email,
      phone: response.phone,
      createdAt: response.createdAt,
      disabled: response.disabled
    }

    const fields: any[] = [];
    const fieldsKeys = Object.keys(input);

    fieldsKeys.map(f => {
      if (input[f].length > 0) {
        fields.push({
          'value': input[f],
          'label': f
        })
      }
    });

    resFormat['fields'] = fields;

    return resFormat;
  }

  /**
   * On User Editing or saving
   */
  onUserDataSubmit = async (input: any) => {
    try {
      if(input.group && input.group.length > 0){
        let newGroup = input.group.reduce(function (accumulator: any, currentValue: any) {
          accumulator[currentValue] = {
            admin: true,
            member: true
          };
          return accumulator;
        }, {});
  
        input.group = newGroup
      }
      if (!!input.id) {// EDITING
        const data = this.getInputDataToSave(input);

        const response = await this._userService.updateById(input.id, data);

        if (response.id) {
          NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userEditSuccess"));
        }
        else {
          NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), 'error');
        }
        await this.getConfig();
        await this.setExtraFieldsState();
      }
      // CREATING
      else {
        const data = this.getInputDataToSave(input);
        const response = await this._userService.create(data);

        if (response.id) {
          NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userSuccess"));
        }
        else {
          NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), 'error');
        }

        await this.getConfig();
        await this.setExtraFieldsState();
      }

      this.setState({
        isLoading: false,
        isRegistrationModalVisible: false
      });
      await this.getUsers(true);
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
    }
    await this.setTable();
  };

  openEditModal = async (editItem: any) => {
    let newFormatGroup: string[] = ['']
    if (editItem.group) {
      newFormatGroup = Object.keys(editItem.group).map(function (key) {
        
        if(_.isString(editItem.group[key])){
          return editItem.group[key];
        }else{
          return key;
        }
      });
      editItem.group = newFormatGroup;
    }
    //newFormatGroup = _.toPlainObject(newFormatGroup)

    const formEditItem = [
      { name: 'id', value: editItem.id },
      { name: 'name', value: editItem.name },
      { name: 'createdAt', value: editItem.createdAt },
      { name: 'create', value: editItem.name },
      { name: 'username', value: editItem.username },
      { name: 'email', value: editItem.email },
      { name: 'phone', value: editItem.phone },
      { name: 'group', value: newFormatGroup },
    ]

    if (editItem.fields && editItem.fields !== null && editItem.fields.length > 0) {
      editItem.fields.map((f: any, k: any) => {
        formEditItem.push({
          name: f.label, value: f.value
        })
      })
    }

    this.setState({
      editItem,
      isRegistrationModalVisible: true,
      formEditItem
    });
  };

  doActiveUser = async (active: boolean, id: string) => {
    try {
      const { tableData } = this.state;
      const targetIndex = findIndex(
        tableData,
        (item: IUser) => item.id === id,
      );
      if (active) {
        tableData[targetIndex] = Object.assign(tableData[targetIndex], { disabled: undefined });
        await this._userService.enableById(id);
      } else {
        tableData[targetIndex] = Object.assign(tableData[targetIndex], { disabled: true });
        await this._userService.disableById(id);
      }
      this.setState({
        isLoading: false,
        tableData,
      });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
      console.error(e);
    }
  }

  activateUser = (active: boolean, id: string) => {
    if (this.currentPillar === 'LI') {
      this.doActiveUser(active, id)
    } else {
      confirm({
        title: active ? I18n.l('user.active') : I18n.l('user.deactivate'),
        content: active ? I18n.l('user.activateMsg') : I18n.l('user.deactivateMsg'),
        okText: active ? I18n.l("common.understand") : I18n.l("common.confirm"),
        okType: 'primary',
        cancelText: I18n.l('common.cancel'),
        onOk: () => {
          this.doActiveUser(active, id)
        }
      })
    }
  };

  handleSearch = ({ searchTerm }: { searchTerm: string }) => {
    const { tableData } = this.state;
    const nextTableData = tableData.filter((item: IUser) => {
      const nameFound = String(item.name).indexOf(searchTerm) > -1;
      return !!nameFound;
    });
    this.setState({
      filteredTableData: searchTerm && searchTerm.length > 1 ? nextTableData : tableData,
    });
  };

  loadMoreHistoryGroup = async (total: number) => {
    
    this.setState({
      groupAmount: this.state.countGroup,
      groupLimit: total + 5
    })


  }

  loadMoreHistory = async (total: number) => {
    this.setState({
      iconLoading: true,
      totalShowData: total + 10
    })
    this.getUsers(false);
  }

  filterData = async (status: any) => {
    await this.setState({
      isLoading: true,
      loadingTable: true,
      disabled: status
    })
    try {
      this.getUsers(true);
    }
    catch (err) {
      console.log(err)
    }
  }

  searchChange = async (event: any) => {
    event.preventDefault();
    this.setState({
      search: event.target.value
    })
  };
  searchDataGroup = async (event: any) => {
    event.preventDefault();

    await this.setState({
      search: event.target.find.value,
      loadingTable: true
    })
    if (event === '') {
      await this.setState({
        search: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    
    this.getGroups();
  }

  searchData = async (event: any) => {
    event.preventDefault();

    await this.setState({
      search: event.target.find.value,
      loadingTable: true
    })
    if (event === '') {
      await this.setState({
        search: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    
    this.getUsers(true);
  }

  updateUserSettings = async (infousers: ConfigGLOBAL) => {
    await this._configService.updateGLOBAL(infousers);
  }

  getConfig = async () => {
    this.setState({ isRegistrationModalVisible: false });
    try {
      const data: any = await this._configService.getGLOBAL();
      this.setState({
        isLoading: false,
        userExtraFields: data.userFields
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        hasExtraFields: true
      });
    }
  };

  getRolesName = async (role: any) => {
    const allRoles = this.state.roles
    const res = allRoles
      .filter((p: any) => p.id === role)
    return res ? res[0] : null
  }

  getGroups = async () => {
    try {
      const data: IPagination<any> = await this._userGroupService.paging({
        unit: this.activeUnitId,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 0,
        // offset: this.state.curOffset
      }, ['id' , 'name', 'permissions']);
      this.setState({
        countGroup: data.count,
        groupTableData: data.items,
        groupTableDataTotal: data.items,
        iconLoading: false

      })
    } catch (error) {
      this.setState({
        iconLoading: false
      })
    }
  }

  getUsers = async (reset: boolean) => {
    this.setState({ isRegistrationModalVisible: false });
    if (reset) {
      this.setState({
        curOffset: undefined,
        isRegistrationModalVisible: false,
        // isLoading: true, // this causes a 'blink' in page
        loadingUsers: true,
        tableData: []
      });
    }
    
    let { groupTableData, groups } = this.state;

    try {
      const dataTableCreate: any = [];
      const data: IPagination<IUser> = await this._userService.paging({
        unit: this.activeUnitId,
        pillar: Pillar[this.currentPillar],
        to: undefined,
        from: undefined,
        search: this.state.search,
        disabled: this.state.disabled,
        limit: 10,
        offset: this.state.curOffset
      });
      const currentUserId = localStorage.getItem(LocalStorageKeys.USER_ID);
      const groupsSource = this.currentPillar === 'LI' ? groups : groupTableData
      for (let user of data.items) {
        
        const groupName = groupsSource.filter((event : any) => {
          let groupIds;
          if(user.group){ 
            groupIds = this.currentPillar === 'LI' ? Object.keys(user.group).map(r => Number(r)) : Object.keys(user.group)

            if(groupIds && groupIds.length > 0){
              return groupIds.includes(event.id)
            }
          }          

        });
        let groupName_s = [];
        if(groupName.length > 0){
          for(const group of groupName){
            groupName_s.push(group.name);
          }
        }
        let roles = []
        if (user.auditor && user.auditor.auditeds && user.auditor.auditeds.length > 0) {
          roles.push(`${I18n.l('table.users.auditor')}`)
        }
        if (user.audited && user.audited.processes && user.audited.processes.length > 0) {
          roles.push(`${I18n.l('table.users.audited')}`)
        }
        let userRoles = '';
        if (user.roles && this.currentPillar && user.roles.length > 0) {
          for (let role of user.roles) {
            if (role.pillar === this.currentPillar && role.unit === this.activeUnitId) {
              const roleName = await this.getRolesName(role.role)
              roles.push(roleName.name)
            }
          }
          userRoles = roles.join(', ');
        }


        const canBeDisabled = !(currentUserId === user.id);
        const _tableData = {
          key: `user_${user.id}`,
          id: user.id,
          name: user.name,
          username: user.username,
          email: user.email,
          phone: user.phone,
          perfil: userRoles,
          createdAt: user.createdAt,
          createdBy: user.createdBy,
          disabled: user.disabled,
          fields: user.fields,
          canBeDisabled,
          group: user.group, 
          group_s: groupName_s.join(", ")
        } as IUser;
        if (user.fields) {
          for (const field of this.state.extraFields) {
            const userField = user.fields.find(f => f.label === field.id);
            let newValue;
            if (userField) {
              if (field.type == FieldType.BOOLEAN) {
                if (userField.value == 'yes' || userField.value == true || userField.value == I18n.l('common.yes'))
                  newValue = I18n.l('common.yes');
                else if (userField.value == 'no' || userField.value == false || userField.value == I18n.l('common.no'))
                  newValue = I18n.l('common.no');
              } else {
                newValue = userField.value;
              }
              const _extraTableData = {
                [`${field.id}`]: newValue || '',
              }
              Object.assign(_tableData, _extraTableData);
            }
          }
        }
        dataTableCreate.push(_tableData);
      }
      let newDataTableCreate: IUser[] = [];
      if (!reset) {
        newDataTableCreate = this.state.tableData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      this.setState({
        isLoading: false,
        loadingUsers: false,
        iconLoading: false,
        userAmount: data.count,
        tableData: newDataTableCreate,
        curOffset: data.offset,
      });
    } catch (error) {
      console.warn(error);
      this.setState({
        isLoading: false,
        loadingUsers: false,
      });
    }
  };

  onUpdate = async (information: ConfigGLOBAL) => {
    try {
      this.props.onUpdate(information);
    } catch (error) {
      console.error(error, 3);
    }
  }

  onCheckboxGroupChange = (extraFieldsCheckboxesIds: any) => {
    this.setState({
      extraFieldsCheckboxesIds
    });
  }
  // In such event of submitting, we persist any changes made from the selected ones to the visible ones. We also set the table again
  onExtraFieldsModalSubmit = async () => {
    this.setState({
      visibleExtraFieldsIds: this.state.extraFieldsCheckboxesIds
    });

    // Clears local storage just in case
    this.state.extraFields.map(extraField => {
      if (extraField.id) {
        localStorage.removeItem(extraField.id);
      }
    });
    //We persist them to the local storage to have them load back again on the next access
    this.state.visibleExtraFieldsIds.forEach((visibleExtraFieldId: string) => {
      localStorage.setItem(visibleExtraFieldId, String(true));
    });

    this.setTable();
    this.toggleExtraFieldsConfigModal();
  }

  // In such event of cancelling, we ignore any changes made, and keep the previously visible fields as the ones checked
  onExtraFieldsModalCancel = () => {
    this.setState({
      extraFieldsCheckboxesIds: this.state.visibleExtraFieldsIds
    });

    this.toggleExtraFieldsConfigModal();
  }
  // This method is used to get the correct extra fields proptype for the select component. If there's a type, there's no placeholder
  getSelectExtraFieldPropType = (type?: FieldType) => {
    const props = {};

    if (type === undefined) {
      props['placeholder'] = I18n.l('users.extraFieldPlaceholder');
    }

    // Extra checking
    else if (type && type in FieldType) {
      props['defaultValue'] = type;
    }

    return props;
  }

  handleListEdit = (index: any) => async () => {

    let _name: string = ''
    let _values: string[] = [];

    // Finding name of such list, if it exists
    if (this.state.userExtraFields && this.state.userExtraFields[index].name !== undefined && this.state.userExtraFields[index].value !== undefined) {
      _name = String(this.state.userExtraFields[index].name);
      _values = this.state.userExtraFields[index].value as string[];
    }

    const list: IUserExtraFieldList = {
      index: index,
      name: _name,
      isVisible: true,
      values: _values
    };

    this.setState({
      currentList: list
    });
  }

  handleListSubmit = (index: number) => async () => {
    const userExtraFields = this.state.userExtraFields;

    userExtraFields[index].value = this.state.currentList.values;

    this.setState({
      userExtraFields
    });

    this.handleListCancel();
  }

  handleListCancel = () => {
    let currentList: IUserExtraFieldList;
    currentList = {
      index: 0,
      name: '',
      isVisible: false,
      values: []
    }

    this.setState({ currentList });
  }

  onDeleteUserExtraFieldOk = async () => {
    await this.setState({
      userExtraFields: this.state.userExtraFields.filter((s, sidx) => this.state.extraFieldToDelete !== sidx),
    });

    this.handleSubmit();
    this.onDeleteUserExtraFieldCancel();
  }

  onDeleteUserExtraFieldCancel = () => {
    this.setState({
      isDeletingExtraField: false,
      extraFieldToDelete: null,
    })
  }

  openDeleteExtraFieldModal = (idx: any) => async () => {
    await this.setState({
      isDeletingExtraField: true,
      extraFieldToDelete: idx,
    });
  }

  handleUserDelete = async (userId: string) => {
    const { tableData } = this.state;
    const nextTableData = tableData.filter((item: IUser) => item.id !== userId);

    try {

      this.setState({ isDeletingUser: true })
      await this._userService.deleteById(userId, { force: false });
      this.setState({
        isLoading: false,
        tableData: nextTableData,
        isDeletingUser: false
      });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.UserDelete"));
    } catch (e) {
      await this.showDeleteConfirm(() => this.forceDelete(userId, nextTableData), () => this.onCancelForceDelete(), e)
      console.error(e);
    }
  }

  forceDelete = async (userId: string, nextTableData: any) => {
    try {
      await this._userService.deleteById(userId, { force: true });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.UserDelete"));
      this.setState({
        isLoading: false,
        tableData: nextTableData,
        isDeletingUser: false
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        isDeletingUser: false
      });
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.delete"), error);
    }
  }
  onCancelForceDelete = async () => {
    this.setState({
      isLoading: false,
      isDeletingUser: false
    });
  }

  showDeleteConfirm(onDelete: Function, onCancelForce: Function, error: string[]) {

    let listErrors: JSX.Element[] = []
    for (let [idx, items] of error.entries()) {
      listErrors.push(
        <div key={idx}>{items}</div>
      )
    }
    confirm({
      title: I18n.l("labels.descriptionDeleteUser").toUpperCase(),
      content: (listErrors),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        onCancelForce()
      },
    });
  }
  
  handleGroupNameChange = async (e: any) => {
    this.setState({groupName: e.target.value})
  }

  createUserGroup = async () => {
    try{
      const {selectedGroupsObject, groupName} = this.state
      const object = {
        name: groupName,
        permissions: selectedGroupsObject
      }
      await this._userGroupService.create(object);
      await  this.getGroups();
      this.clearUserGroupState();
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.groupEdited"));
    } catch (e){
      NotificationComponent.Notify('error', I18n.l("common.error"), 'error');
    }
  }

  cancelGroupCreation = async () => {
    this.clearUserGroupState()
    this.setState({registerGroupModal: false})
  }
  
  clearUserGroupState = async () => {
    this.setState({
      registerGroupModal: false, 
      selectedGroupsObject: {}, 
      groupName: '', 
      editedGroupPermissions: [],
      editionMode: false})
  }

  handleUserPermissionSelect = async (e: any) => {
    
    let selectedGroupsObject = {}
    if(this.state.selectedGroupsObject){
      selectedGroupsObject = this.state.selectedGroupsObject
    }
    const keyAndValueArray = e.target.value.split('-')
    
    if(e.target.checked){
      if(selectedGroupsObject[keyAndValueArray[0]]){
        selectedGroupsObject[keyAndValueArray[0]].push(keyAndValueArray[1])
      } else {
        selectedGroupsObject[keyAndValueArray[0]] = [keyAndValueArray[1]]
      }
    } else {
      if(selectedGroupsObject[keyAndValueArray[0]]){
        selectedGroupsObject[keyAndValueArray[0]] = selectedGroupsObject[keyAndValueArray[0]].filter(e => e !== keyAndValueArray[1])
      }
    }

    const editedGroupPermissions = await this.changedEditedGroupPermissions(selectedGroupsObject)
    this.setState ({ selectedGroupsObject, editedGroupPermissions })
  }

  changedEditedGroupPermissions = async (permissionObj: any) => {
    const editedGroups: any = [];

    for(let group in permissionObj){
      permissionObj[group].forEach((permission: any) => {
        editedGroups.push(`${group}-${permission}`)
      })
    }

    return editedGroups;
  }

  async loadGroups() {
    this.setState({ loadingGroups: true })

    try {
      let { listUserGroups }: any = await groupService.listUserGroups()
      this.setState({ groups: listUserGroups, loadingGroups: false })
    } catch (e) {
      console.error(e)
      this.setState({ loadingGroups: false })
      alert('Erro ao carregar os grupos.')
    }
  }

  render() {
    const { 
      isLoading, groupTableData, tableData, filteredTableData, editItem, userAmount, totalShowData, disabled, search, extraFields, formEditItem, groups, loadingGroups, loadingUsers
    } = this.state;
    let _extraFields: IField[];
    let groupTableDataShow = groupTableData.slice(0,this.state.groupLimit);

    if (extraFields) {
      // _extraFields = extraFields.filter(x => x.type !== FieldType.SELECT);
      _extraFields = extraFields;
    }
    else {
      _extraFields = [];
    }

    if (!(this.state.loadingTable)) {
      if (!!isLoading) {
        return (
          <AppContext.Consumer>
            {({ locale, activeUnitId }) => (
              this.locale = locale,
              this.activeUnitId = activeUnitId,
              <span>{I18n.l('common.loadingTable')}</span>
            )}
          </AppContext.Consumer>
        )
      }
    }

    let extraFieldsCheckboxesRows: JSX.Element[] = [];

    extraFieldsCheckboxesRows = this.state.extraFields.map((el: any) => {
      return (
        <Col key={el.id} span={24} style={{ marginBottom: "1rem" }}>
          <Checkbox value={el.id}>{el.name}</Checkbox>
        </Col>
      )
    })

    return (

      <AppContext.Consumer>
        {({ locale, activeUnitId }) => (
          this.locale = locale,
          this.activeUnitId = activeUnitId,
          <Page>
            <Wrapper>
              <Tabs style={{ width: '100%' }} activeKey={this.state.activeKey} onChange={this.onTabChange} >
                {(this.currentPillar === 'LI' ? verifyItemPermission(null, 'can_view_users', null, true) : true) && <TabPane tab={I18n.l('users.registeruser')} key={"1"}>
                  <Toolbar>
                    <ToolbarItem>
                      {(this.currentPillar === 'LI' ? verifyItemPermission(null, 'can_create_users', null, true) : true) && <RegisterBtnComponent
                        onClick={() => this.toggleFormModal(true)}
                        buttonText={I18n.l('common.register') + " " + I18n.l('labels.user')}
                      />}
                    </ToolbarItem>
                    <ToolbarItem>
                      <div className='goepik-component-tablesize'>
                        <SearchComponent
                          onSubmit={this.searchData}
                          placeholder='form.placeholders.usersSearch'
                          defaultValue={search}
                          buttonText='form.buttons.search'
                        />
                      </div>
                    </ToolbarItem>
                  </Toolbar>

                  <Row>
                    <Col style={{ marginBottom: '2rem' }} md={24} xl={8} xxl={5}>
                      <FilterComponent
                        label='form.filter.label.users'
                        onClick={this.filterData}
                        buttons={{
                          text: {
                            active: 'form.filter.button.text.active',
                            deactive: 'form.filter.button.text.deactive',
                            all: 'form.filter.button.text.all',
                          }
                        }}
                        disabled={disabled}
                      />
                    </Col>
                    {/* <Col md={24} xl={8} xxl={6} >
                      <h2>Filtrar por grupo</h2>
                      <div>
                        <Select size='large' placeholder='Filtrar por grupo' style={{ width: '70%' }}>
                          <Option value={''}>{I18n.l('dashboard.allUsers')}</Option>
                          {this.listGroups()}
                        </Select>
                      </div>
                    </Col> */}
                  </Row>


                  {!!isLoading && !loadingUsers && (
                    <span>{I18n.l('common.loadingTable')}</span>)
                  }
                  {(!isLoading) && (extraFieldsCheckboxesRows.length > 0) && (
                    <Button className="goepik-btn-border-main" onClick={this.toggleExtraFieldsConfigModal}>
                      {I18n.l("permissions.customTable")}
                    </Button>
                  )}
                  {(this.state.isConfigExtraFieldsModalVisible && extraFieldsCheckboxesRows.length > 0) && (
                    <GoEpikModal onClose={this.toggleExtraFieldsConfigModal} isOpen={this.state.isConfigExtraFieldsModalVisible}>
                      <ModalTitle>{I18n.l('form.titles.customtable')}</ModalTitle>
                      <p>{I18n.l('form.titles.desccustomtable')}</p>
                      <ModalContent>

                        <CheckboxGroup defaultValue={this.state.visibleExtraFieldsIds} onChange={this.onCheckboxGroupChange}>
                          <Row>
                            {extraFieldsCheckboxesRows}
                          </Row>
                        </CheckboxGroup>

                        {/* Submit button */}
                        <RegisterBtnComponent
                          style={{ float: "right", marginLeft: "1rem" }}
                          buttonText={I18n.l('common.save')}
                          onClick={this.onExtraFieldsModalSubmit} />

                        {/* Cancel button */}
                        <Button style={{ float: "right" }} size="large" className="link primary bolder" onClick={this.onExtraFieldsModalCancel}>
                          {I18n.l('common.cancel')}
                        </Button>

                      </ModalContent>
                    </GoEpikModal>
                  )}
                  {/* Table Area */}
                  {!loadingUsers && (tableData.length > 0) && (this.state.tableColumns) && (
                    <div className={'goepik-component-tablesize'} >
                      <TableComponent
                        columns={this.state.tableColumns}
                        data={filteredTableData.length > 0 ? filteredTableData : tableData}
                        onDelete={this.handleUserDelete}
                        onEdit={this.openEditModal}
                        onActive={this.activateUser}
                        noPagination={true}
                        showConfirmationModal={false}
                        disabledLoading={this.state.isDeletingUser}
                        editPermission="can_edit_users"
                        deletePermission="can_delete_users"
                        pillar={this.currentPillar}
                        isUser
                      />
                    </div>
                  )}

                  {loadingUsers && (<div>{I18n.l('units.loadingUsers')}</div>)}
              
                  {/* Load More button */}
                  {userAmount >= 10 && (
                    <Button
                      className="loading-more"
                      type="primary"
                      loading={this.state.iconLoading}
                      onClick={() => this.loadMoreHistory(totalShowData)}
                      size='large'
                      ghost
                    >
                      {I18n.l('common.seeMore')}
                    </Button>
                  )}

                  {/* User registration Modal */}
                  {!loadingUsers && tableData.length === 0 && !isLoading && <p>{this.locale && I18n.l('common.noResult')}</p>}
                  {this.state.isRegistrationModalVisible && (
                    <Modal
                      footer={null}
                      closable={false}
                      visible={this.state.isRegistrationModalVisible}
                      keyboard={true}
                    >
                      {/* {extraFieldsInput} */}
                      <ModalTitle>{I18n.l('form.titles.usersForm')}</ModalTitle>
                      <ModalContent>
                        {this.currentPillar === 'LI' && !loadingGroups && <UsersForm
                          listGroups={groups}
                          data={editItem}
                          extraFields={_extraFields}
                          onSubmit={this.onUserDataSubmit}
                          onCancel={this.toggleFormModal}
                          shouldFilterGroup
                        />}

                        {this.currentPillar !== 'LI' && <UsersForm
                          listGroups={groupTableData}
                          data={editItem}
                          extraFields={_extraFields}
                          onSubmit={this.onUserDataSubmit}
                          onCancel={this.toggleFormModal}
                        />}
                      </ModalContent>
                    </Modal>
                  )}
                </TabPane>}

                {(this.currentPillar === 'LI' ? verifyItemPermission(null, 'can_view_groups', null, true) : true) && <TabPane tab={I18n.l('label.groups')} key='4'>
                  {this.currentPillar === 'LI' && <GroupManager onLoadGroups={this.loadGroups} groups={groups} loadingGroups={loadingGroups} />}
                  {this.currentPillar !== 'LI' && <>
                  <Toolbar>
                    <ToolbarItem>
                      <RegisterBtnComponent
                        onClick={this.toggleModalGroup}
                        buttonText={I18n.l('common.register') + " " + I18n.l('label.group')}
                      />
                    </ToolbarItem>
                    <ToolbarItem>
                      <SearchComponent
                        onSubmit={this.searchDataGroup}
                        placeholder='form.placeholders.groupSearch'
                        defaultValue={search}
                        buttonText='form.buttons.search'
                      />
                    </ToolbarItem>
                  </Toolbar>
                  {groupTableData.length > 0 && (
                    <div className="goepik-component-tablesize">
                      <TableComponent
                        columns={groupsColumns}
                        data={groupTableDataShow}
                        noPagination={true}
                        showConfirmationModal={false}
                        onDelete={this.deleteGroup}
                        onEdit={this.openEditGroup}
                      />
                    </div>
                  )}
                    {/* Load More button */}
                    {this.state.groupLimit <= this.state.countGroup && (
                    <Button
                      className="loading-more"
                      type="primary"
                      loading={this.state.iconLoading}
                      onClick={() => this.loadMoreHistoryGroup(this.state.groupLimit)}
                      size='large'
                      ghost
                    >
                      {I18n.l('common.seeMore')}
                    </Button>
                  )}                  {groupTableData.length === 0 && <p>{locale && I18n.l('common.noResult')}</p>}
                  <PaddingRemover>
                      <Modal
                        closable={false}
                        className={"no-padding"}
                        visible={this.state.registerGroupModal}
                        keyboard={true}
                        width={'60%'}
                        destroyOnClose={true}
                        onCancel={this.cancelGroupCreation}
                        onOk={this.state.editionMode ? this.editPermissions : this.createUserGroup}
                      >
                        <ModalHeader >
                            <h3>{I18n.l('permissions.createGroupBtn')}</h3>
                          </ModalHeader>
                        <UsersModalContent>
                          <div className="steps">
                            <StepsVisualizer 
                              stepsObjectArray={[{icon: 'user', label: 'users.from.group'}]}
                            />
                          </div>
                          <Divider style={{ width: '102.7%', height: 3 }} />
                        <div className="group-container">
                          <div className="input-field">
                            <h4>{I18n.l('form.titles.groupForm')}</h4>
                            <Input
                            placeholder={I18n.l('form.titles.groupForm')}
                            onBlur={this.handleGroupNameChange}
                            defaultValue={this.state.edititemsGroup.name}
                            />
                          </div>
                        </div>
                        <Divider style={{width: '100%', height: 3}} />
                        <div className="table-container">
                          <table style={{width: '100%', borderSpacing: '1em', borderCollapse: 'separate'}}>
                            <thead>
                              <tr>
                                <th className="title" width="44%">{I18n.l('common.name')}</th>
                                <th className="title">{I18n.l('create.permission')}</th>
                                <th className="title">{I18n.l('common.delete')}</th>
                                <th className="title">{I18n.l('common.edit')}</th>
                                <th className="title">{I18n.l('common.visualize')}</th>
                              </tr>
                            </thead>
                            <tbody>
                                {this.state.components.map(e => {
                                  return (
                                    <tr key={`${e.key}`}>
                                      <td><p className="route">{I18n.l(`${e.label}`)}</p></td> 
                                      <td><Checkbox onChange={this.handleUserPermissionSelect} checked={this.state.editedGroupPermissions ? this.state.editedGroupPermissions.includes(`${e.key}-create`) : false} value={`${e.key}-create`}/></td>
                                      <td><Checkbox onChange={this.handleUserPermissionSelect} checked={this.state.editedGroupPermissions ? this.state.editedGroupPermissions.includes(`${e.key}-delete`) : false} value={`${e.key}-delete`}/></td>
                                      <td><Checkbox onChange={this.handleUserPermissionSelect} checked={this.state.editedGroupPermissions ? this.state.editedGroupPermissions.includes(`${e.key}-edit`) : false} value={`${e.key}-edit`}/></td>
                                      <td><Checkbox onChange={this.handleUserPermissionSelect} checked={this.state.editedGroupPermissions ? this.state.editedGroupPermissions.includes(`${e.key}-visualize`) : false} value={`${e.key}-visualize`}/></td>
                                    </tr> 
                                  )
                                })}
                            </tbody>
                            </table>
                        </div>
                        </UsersModalContent>
                      </Modal>
                  </PaddingRemover>
                  </>}
                </TabPane>}

                {/* Add information tab */}
                {(this.currentPillar === 'LI' ? verifyItemPermission(null, 'can_view_add_info', null, true) : true) && <TabPane tab={I18n.l('users.tabinfo')} key={"2"}>
                    <Row>
                      <Col span={12}>
                       <p>
                          {I18n.l('users.infoextrafields1')}
                          {I18n.l('users.infoextrafields2')}
                          {I18n.l('users.infoextrafields3')}
                        </p>
                        <div>
                          <Row style={{ display: 'flex', marginTop: "1rem" }} >
                            <div style={{ width: "50%" }}>
                              <span >{I18n.l('users.namefield')}</span>
                            </div>
                            <div style={{ width: "50%", marginLeft: "45px" }}>
                              <span >{I18n.l('users.typefield')}</span>
                            </div>
                          </Row>
                        </div>
                        <form>
                          {(this.state.userExtraFields) && (this.state.userExtraFields.map((extraField: IField, idx: number) => (
                            <div className="shareholder goepik-component-padding" key={idx}>
                              <Row>
                                <Input
                                  defaultValue={extraField.name}
                                  style={{ width: '50%' }}
                                  value={extraField.name}
                                  placeholder={I18n.l('users.placeholderfield')}
                                  onChange={this.handleUserExtraFieldNameChange(idx)}
                                />
                                <Select disabled={!!extraField.id} style={{ width: '35%', marginLeft: "30px" }} onChange={this.handleUserExtraFieldTypeChange(idx)} {...this.getSelectExtraFieldPropType(extraField.type)}>
                                  <Option value={FieldType.TEXT}>{I18n.l('users.text')}</Option>
                                  <Option value={FieldType.NUMBER}>{I18n.l('users.number')}</Option>
                                  <Option value={FieldType.DATE}>{I18n.l('users.date')}</Option>
                                  <Option value={FieldType.BOOLEAN}>{I18n.l('users.boolean')}</Option>
                                  <Option value={FieldType.LIST}>{I18n.l('users.list')}</Option>
                                </Select>

                                {extraField.type === FieldType.LIST && (
                                  <Button className="goepik-btn-icon" style={{ padding: '10px', marginTop: '-5px', fontSize: '12px' }} onClick={this.handleListEdit(idx)}>
                                    <FontAwesomeIcon
                                      style={{ color: '#366bff', cursor: "pointer" }}
                                      icon={'pen'}
                                    />
                                  </Button>
                                )}

                                {!extraField.undeletable && (
                                  <Icon
                                    style={{ color: 'red', cursor: "pointer" }}
                                    className="dynamic-delete-button"
                                    type="close"
                                    onClick={this.openDeleteExtraFieldModal(idx)}
                                  />
                                )}
                              </Row>
                            </div>
                          )))}

                          {(this.state.isDeletingExtraField) && (
                            <Modal
                              visible={this.state.isDeletingExtraField}
                              destroyOnClose={true}
                              onOk={this.onDeleteUserExtraFieldOk}
                              onCancel={this.onDeleteUserExtraFieldCancel}
                              cancelText={I18n.l('common.cancel')}
                              okText={I18n.l('common.delete')}
                            >
                              <ModalTitle>{I18n.l('users.extraFieldDeleteModalTitle')}</ModalTitle>

                              <ModalContent>
                                <p>{I18n.l('users.extraFieldDeleteModalMessage')}</p>
                              </ModalContent>
                            </Modal>
                          )}
                          <div className="goepik-component-padding">
                            <Button style={{ marginTop: '10px' }} size="large" className="goepik-btn-border-main" onClick={this.handleAddUserExtraField}>
                              <Icon type="plus" /> {I18n.l('users.addfield').toUpperCase()}
                            </Button>
                          </div>
                        </form>
                        <div className="goepik-component-padding" >
                          <Button type="primary" size="large" className="goepik-btn-primary-main" onClick={this.handleSubmit} >
                            {I18n.l('users.save').toUpperCase()}
                          </Button>
                        </div>
                      </Col>
                      <Col span={12}>
                        {/* {(this.state.currentList.isVisible) && ( */}
                        <Modal
                          footer={false}
                          visible={this.state.currentList.isVisible}
                          // style={{ margin: "1rem" }}
                          title={`${I18n.l('users.extraFieldListTitle')}: ${this.state.currentList.name}`}
                        >
                          <form>
                            {(this.state.currentList.values.map((listItem: string, index: number) => (
                              <Row>
                                <Input key={index}
                                  defaultValue={listItem}
                                  placeholder={I18n.l('users.placeholderfield')}
                                  value={listItem}
                                  style={{ width: "80%", marginBottom: "1rem" }}
                                  onChange={this.handleListFieldValueChange(index)}
                                />

                                <Icon
                                  style={{ color: 'red', marginLeft: '10px', cursor: "pointer" }}
                                  className="dynamic-delete-button"
                                  type="close"
                                  // disabled={x.lenght === 1}
                                  onClick={this.handleRemoveListItem(index)}
                                />
                              </Row>
                            )))}
                            <div className="goepik-component-padding">
                              <Button style={{ marginTop: '10px' }} size="large" className="goepik-btn-border-main" onClick={this.handleAddNewListItem}>
                                <Icon type="plus" /> {I18n.l('users.addfield').toUpperCase()}
                              </Button>
                            </div>
                            <div className="goepik-component-padding">
                              <Button disabled={this.state.currentList.values.length === 0} type="primary" size="large" className="goepik-btn-primary-main" onClick={this.handleListSubmit(this.state.currentList.index)} >
                                {I18n.l('users.save').toUpperCase()}
                              </Button>
                              <Button ghost type="primary" size="large" className="goepik-btn-primary-main" onClick={this.handleListCancel} >
                                {I18n.l('common.cancel').toUpperCase()}
                              </Button>
                            </div>
                          </form>
                        </Modal>
                      </Col>
                    </Row>
                  </TabPane>}
    
                {(this.currentPillar === 'LI' ? verifyItemPermission(null, 'can_view_export', null, true) : true) && <TabPane tab={I18n.l('editables.labels.registerExport')} key={"3"}>
                    <ExportContainer pillar={this.currentPillar} />
                  </TabPane>}
              </Tabs>
            </Wrapper>
          </Page>
        )}
      </AppContext.Consumer>
    );
  }
}

//#region CSS
const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  .loading-more {
      margin: 15px 0;
      padding: 0;
      border: 0;
      text-align: left
  }

  .filter-group {
      margin-bottom: 50px;
  }
`;


const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

injectGlobal`
  .no-padding{
    .ant-modal-body{
    padding: 0;
    
  }
  .ant-modal-content{
    border-radius: 6px;
  }

  .teste{
    .ant-menu-item-active{
      color: black;
    }
  }
}
`

const UsersModalContent = styled.div`
  padding: 15px;
  font-family: Montserrat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .steps{
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .group-container{
    width: 100%;
    padding: 15px;
    padding-bottom: 0;
    h4{
      text-transform: uppercase;
      font-family: inherit;
      color: #8493AA;
      font-weight: 600;
      font-size: 0.8em;
    }
    .input-field{
      margin-left: 5%;
      input{ 
        width: 30%;
      } 
    }
  }
  .table-container{
    .route{
      color: #6B6B6B;
    }
    width: 87%;
    .title{
    color: #8493AA;
    font-size: 1.2em;
    font-family: inherit;
    font-weight: 500;
    }
    td{
      .ant-checkbox-wrapper{
        transform: translateX(13%);
      }
    }
  }
  .ant-checkbox-inner:after{
    transform: translate(-10px, -11px) rotate(45deg) scale(0.35);
  }
  .ant-checkbox-inner{
    width: 20px;
    height: 20px;
  }
`


const PaddingRemover = styled.div`
  padding: 0;
`


const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;

  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
  width: 100%;
`;

export const UsersContainer = Form.create()(UsersContainerClass);

//#endregion